<template>
  <div class="invite-tenant">
    <invite-tenant :collaborator="!isBeaconAdmin"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import inviteTenant from '../../components/manage/inviteTenant.vue'
export default {
  components: { inviteTenant },
  computed: {
    ...mapGetters(['isBeaconAdmin'])
  }
}
</script>

<style lang="scss" scoped >

</style>
